
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "@/lib/api";
import { queryKeys } from "@/lib/query-keys";
import type { CreateReportRequest, ReviewReportRequest } from "@/lib/types";

export function useMyReports() {
  return useQuery({
    queryKey: queryKeys.reports.mine(),
    queryFn: api.getMyReports,
  });
}

export function useAdminReports(status?: string) {
  return useQuery({
    queryKey: queryKeys.reports.admin(status),
    queryFn: () => api.getAdminReports(status),
  });
}

export function useCreateReport(examSlug: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateReportRequest) =>
      api.createReport(examSlug, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.reports.mine() });
    },
  });
}

export function useReviewReport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: ReviewReportRequest;
    }) => api.reviewReport(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.reports.admin() });
    },
  });
}
